// All action times

const activityLogs = {
  REQUEST_ACTIVITY_LOGS: 'REQUEST_ACTIVITY_LOGS',
  RECEIVE_ACTIVITY_LOGS: 'RECEIVE_ACTIVITY_LOGS',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  FILTER_LOGS: 'FILTER_LOGS',
};

export default activityLogs;



// WEBPACK FOOTER //
// src/routes/ActivityLogs/actions/actiontypes.js